<template>
  <el-tooltip effect="light" placement="right" v-if="rows && rows.length > 0">
    <el-table slot="content" :data="rows" size="mini" :show-header="false" stripe>
      <el-table-column label="客户/标题" width="250">
        <template slot-scope="{ row }">
          <p>
            <el-tag type="danger" size="mini">{{ row.Frequency == 0 ? '新' : row.Frequency }}</el-tag>
            {{ row.Customer }}
          </p>
          <div class="describe">
            <p>{{ row.Title }}</p>
            <p>{{ row.Mode }} - {{ row.Code }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="{ row }">
          <p v-if="row.State != 9">{{ row.StateText }}</p>
          <p v-else>{{ row.ResultText }}</p>
        </template>
      </el-table-column>
    </el-table>
    <div class="info">
      <label v-for="row in groupTotal" :key="row.type">{{ row.type }}+{{ row.value }}</label>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    rows: { type: Array, default: null }
  },
  computed: {
    groupTotal () {
      let key = "Mode"
      let res = [], types = {}
      this.rows.forEach(row => {
        if (!(row[key] in types)) {
          types[row[key]] = { type: row[key], value: 0 }
          res.push(types[row[key]])
        }
        types[row[key]].value += 1
      })
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>